var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box table-scroll" },
    [
      _c(
        "b-table",
        {
          attrs: { data: _vm.rows, narrowed: "", hoverable: "", fullwidth: "" },
          scopedSlots: _vm._u([
            {
              key: "empty",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "has-text-centered has-text-grey" },
                    [_vm._v("\n        No data available\n      ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.$store.getters.hasAnyRole(["lyris"])
            ? _c("b-table-column", {
                attrs: { field: "orgName", label: "Org", centered: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _vm._v(
                            "\n      " + _vm._s(props.row.orgName) + "\n    "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1671764608
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.columns, function (col) {
            return _c("b-table-column", {
              key: col.field,
              attrs: { field: col.field, label: col.label, centered: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "cell-wrapper",
                            class: _vm.cellClass(props.row, col),
                            on: {
                              click: function ($event) {
                                return _vm.onCellClick(props.row, col)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(props.row[col.field]) +
                                "\n      "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }